import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import {
  TopNavigation,
  Acceptance,
  Comment,
  CommentsList,
} from '../../components';
import { Button, Box, Typography } from '@material-ui/core';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import { OLD_QUESTIONNAIRE_SAMPLE } from '../../constants/volunteers';
import {
  SERVER_HOST,
  VOLUNTEERS_ENDPOINT,
  COMMENTS_ENDPOINT,
} from '../../constants/endpoints';
import AddCommentIcon from '@material-ui/icons/AddComment';
import { AuthenticationContext } from '../../hooks/global/AuthenticationContext';
import Authorization from '../Authorization';
import utils from '../../utils';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import '../../styles/components/volunteers/volunteer-full/desktop.scss';
import '../../styles/components/volunteers/volunteer-full/tablet.scss';
import '../../styles/components/volunteers/volunteer-full/mobile.scss';
import { Tooltip } from '@mui/material';

const VolunteerFull = () => {
  let counter = 0;
  const { userID } = useParams();
  const [data, setData] = useState(null);
  const [isAcceptance, setAcceptance] = useState(false);
  const [comments, setComments] = useState(null);
  const [isCommentWindowOpened, setCommentWindowStatus] = useState(false);
  const [isDeletingSuccessDialog, setDeletingSuccessDialog] = useState(false);
  const { isAuthenticated } = useContext(AuthenticationContext);

  useEffect(() => {
    const fetchData = async () => {
      await fetch(SERVER_HOST + VOLUNTEERS_ENDPOINT + `/${userID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((result) => setData(result))
        .then(() =>
          fetch(SERVER_HOST + COMMENTS_ENDPOINT(userID), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then((response) => response.json())
            .then((result) => {
              setComments(result);
            })
        )
        .catch(
          (errorText) =>
            comments &&
            alert(
              'Произошла ошибка. Пожалуйста, отправьте следующий ' +
                'текст ошибки администратору сайта на it@gold-race.org: ' +
                errorText
            )
        );
    };

    fetchData();
  }, [userID, isCommentWindowOpened, isDeletingSuccessDialog]);

  return (
    <div className="volunteer-full">
      {isAuthenticated ? (
        <>
          <TopNavigation
            volunteerFullName={
              data &&
              (`${data.lastName} ${data.firstName} ${
                data.middleName !== OLD_QUESTIONNAIRE_SAMPLE
                  ? data.middleName
                  : ''
              }` ||
                'Н/О')
            }
          />

          {data && (
            <>
              <Acceptance
                fullName={`${data.lastName} ${data.firstName} ${
                  data.middleName !== OLD_QUESTIONNAIRE_SAMPLE
                    ? data.middleName
                    : ''
                }`}
                open={isAcceptance}
                handleClose={() => setAcceptance(isAcceptance ? false : true)}
                userID={userID}
              />
              <Comment
                open={isCommentWindowOpened}
                handleClose={() => setCommentWindowStatus(false)}
                fullName={
                  data
                    ? `${data.lastName} ${data.firstName} ${data.middleName}`
                    : 'ФИО не определены'
                }
                userID={userID}
              />
            </>
          )}

          <div className="full-name-and-actions">
            <Typography className="full-name" variant="h4" gutterBottom>
              {data &&
                (`${data.lastName} ${data.firstName} ${
                  data.middleName !== OLD_QUESTIONNAIRE_SAMPLE
                    ? data.middleName
                    : ''
                }` ||
                  'Н/О')}
            </Typography>
            <div className="actions">
              <Button
                variant="contained"
                color="primary"
                onClick={() => setAcceptance(true)}
              >
                <AssignmentIndIcon style={{ marginRight: '5px' }} />
                Закрепить
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  // TODO: раскоммитить после того, как будет изменена
                  // СУБД на сервере с Google Firebase на GoldenRaceDB
                  // setCommentWindowStatus(true);
                  alert(
                    'Уважаемые члены Совета! Функция добавления комментариев ' +
                      'временно не работает, поскольку ОИТ ещё не завершил ' +
                      'работы по миграции данных. Приносим извинения за ' +
                      'предоставленные неудобства.'
                  );
                }}
              >
                <AddCommentIcon style={{ marginRight: '5px' }} />
                Комментировать
              </Button>
            </div>
          </div>

          {comments && comments.length > 0 ? (
            <Box mt={3}>
              <CommentsList
                comments={comments}
                userID={userID}
                isDeletingSuccessDialog={isDeletingSuccessDialog}
                setDeletingSuccessDialog={setDeletingSuccessDialog}
              />
            </Box>
          ) : (
            <></>
          )}

          <Box mt={3}>
            <Typography variant="h5" gutterBottom>
              Анкета волонтёра
            </Typography>
            {data &&
              (() => {
                const {
                  lastName,
                  firstName,
                  middleName,
                  day,
                  month,
                  year,
                  phone,
                  email,
                  address,
                  learningStartYear,
                  learningTotal,
                  readBooks,
                  isSpreader,
                  spreadingExamples,
                  chatActivities,
                  education,
                  profession,
                  hobby,
                  software,
                  energyPracticies,
                  spiritualProbabilities,
                  initiatedCreativitiesByBooks,
                  workingHoursPerMonth,
                  promotionIdeas,
                  knowledgeInfluence,
                  languages,
                } = data;

                return (
                  <Box mt={2}>
                    <table style={{ borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <th
                            style={{
                              textAlign: 'center',
                              border: '1px solid black',
                            }}
                          >
                            <Typography variant="body1">
                              <b>#</b>
                            </Typography>
                          </th>
                          <th
                            style={{
                              textAlign: 'center',
                              border: '1px solid black',
                            }}
                          >
                            <Typography variant="body1">
                              <b>Вопрос анкеты</b>
                            </Typography>
                          </th>
                          <th
                            style={{
                              textAlign: 'center',
                              border: '1px solid black',
                            }}
                          >
                            <Typography variant="body1">
                              <b>Ответ волонтёра</b>
                            </Typography>
                          </th>
                        </tr>
                        <tr></tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              <b>ФИО*</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {`${lastName} ${firstName} ${
                                middleName !== OLD_QUESTIONNAIRE_SAMPLE
                                  ? middleName
                                  : ''
                              }`}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              <b>Дата рождения*</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {`${day}.${month}.${year} (возраст: ${utils.calculateAge(
                                  year
                                )})`}
                                <Tooltip
                                  placement="right-end"
                                  fontSize="small"
                                  title={
                                    'Возраст рассчитывается на основе вычитания года ' +
                                    'рождения из текущего года. Может быть погрешность ±1 год.'
                                  }
                                  style={{
                                    marginLeft: '4px',
                                  }}
                                >
                                  <HelpOutlineIcon />
                                </Tooltip>
                              </div>
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              <b>Номер телефона*</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {phone ? phone : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              <b>Эл. почта*</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {email ? email : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              <b>Адрес фактического проживания*</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {address ? address : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Начало знакомства с трудами Авторов Л.А.
                              Секлитовой, Л.Л. Стрельниковой, год
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {learningStartYear ? learningStartYear : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Количество лет изучения трудов Авторов
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {learningTotal ? learningTotal : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Количество прочитанных книг Авторов Л.А.
                              Секлитовой, Л.Л. Стрельниковой
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {readBooks ? readBooks : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Вы участвуете в распространении книг Л.А.
                              Секлитовой и Л.Л. Стрельниковой в Интернете? Если
                              да, приведите, пожалуйста, ссылки на посты
                              Вконтакте, Одноклассников, Фейсбука
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {spreadingExamples ? spreadingExamples : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Вы участвуете в работе чатов по изучению книг
                              Авторов Л.А. Секлитовой и Л.Л. Стрельниковой? Если
                              да, напишите, пожалуста, названия этих чатов
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {chatActivities ? chatActivities : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">Образование</Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {education ? education : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">Профессия</Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {profession ? profession : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">Хобби</Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {hobby ? hobby : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Навыки владения компьютером (программы), уровень
                              (начальный, средний, уверенный, продвинутый)
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {software ? software : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Какими энергопрактиками Вы владеете и с какого
                              года
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {energyPracticies ? energyPracticies : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Какими паранормальными способностями обладаете
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {spiritualProbabilities
                                ? spiritualProbabilities
                                : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Какие творческие способности открылись у Вас при
                              изучении книг Л.А. Секлитовой и Л.Л. Стрельниковой
                              (кратко)
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {initiatedCreativitiesByBooks
                                ? initiatedCreativitiesByBooks
                                : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Количество часов в неделю, которое планируется
                              отводить для работы в Духовном Центре
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {workingHoursPerMonth
                                ? workingHoursPerMonth
                                : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Какие идеи по распространению Нового Учения можете
                              предложить
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {promotionIdeas ? promotionIdeas : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Как изучение книг Л.А. Секлитовой и Л.Л.
                              Стрельниковой повлияло на Вашу жизнь (здоровье,
                              отношение с людьми, мировоззрение и т.д.)
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {knowledgeInfluence ? knowledgeInfluence : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Какие иностранные языки Вы знаете
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {languages ? languages : '–'}
                            </Typography>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              border: '1px solid black',
                              padding: '5px',
                            }}
                          >
                            <Typography variant="body1">
                              <b>{++counter}</b>
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              Даю согласие на работу в Духовном Центре Новых
                              Знаний «Золотая Раса» на благотворительной основе
                              для распространения Новых Знаний
                            </Typography>
                          </td>
                          <td
                            style={{ border: '1px solid black', width: '50%' }}
                          >
                            <Typography variant="body1">
                              {isSpreader ? 'Да' : 'Нет'}
                            </Typography>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Box>
                );
              })()}
          </Box>
        </>
      ) : (
        <Authorization />
      )}
    </div>
  );
};

export default VolunteerFull;
